/** Shared small widgets: panel, number field with validation, select. */
import type { ComponentChildren } from "preact";
import { issues } from "../state/store";

export function Panel(props: { title?: string; children: ComponentChildren; class?: string }) {
  return (
    <div class={`panel ${props.class ?? ""}`}>
      {props.title && <h2>{props.title}</h2>}
      {props.children}
    </div>
  );
}

export function issueFor(path: string): { message: string; severity: string } | undefined {
  return issues.value.find((i) => i.path === path && i.severity === "error")
    ?? issues.value.find((i) => i.path === path);
}

export function NumberField(props: {
  label: string;
  value: number;
  onChange: (v: number) => void;
  path?: string;
  unit?: string;
  step?: number;
  min?: number;
  compact?: boolean;
}) {
  const issue = props.path ? issueFor(props.path) : undefined;
  const error = issue?.severity === "error";
  return (
    <div class={`field ${props.compact ? "compact" : ""}`}>
      <label>
        <span class="field-label">{props.label}</span>
        <span class="field-input">
          <input
            type="number"
            value={props.value}
            step={props.step ?? 0.01}
            min={props.min}
            class={error ? "invalid" : ""}
            onInput={(e) => {
              const v = parseFloat((e.target as HTMLInputElement).value);
              if (Number.isFinite(v)) props.onChange(v);
            }}
          />
          {props.unit && <span class="field-unit">{props.unit}</span>}
        </span>
      </label>
      {issue && <div class={`field-issue ${issue.severity}`}>{issue.message}</div>}
    </div>
  );
}

export function Select<T extends string>(props: {
  label?: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
}) {
  return (
    <label class="field select-field">
      {props.label && <span class="field-label">{props.label}</span>}
      <select value={props.value} onChange={(e) => props.onChange((e.target as HTMLSelectElement).value as T)}>
        {props.options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
